export default __webpack_public_path__ + "static/media/image.ceylon-project.ec00c395.png";